import {
    FETCH_USER,
    FETCH_USERS,
    FETCH_USERS_ACCUMULATED,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    FETCH_USER_ACCUMULATED,
    FETCH_USER_FAILURE,
    FETCH_USER_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchUsers = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'company_name',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (payload.company_name) {
        params.company_name = payload.company_name;
    }

    if (payload.username) {
        params.username = payload.username;
    }

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_USERS,
        payload: params,
    };
};

export const fetchUsersFailure = (error) => {
    return {
        type: FETCH_USERS_FAILURE,
        error: error,
    };
};

export const fetchUsersSuccess = (payload) => {
    return {
        type: FETCH_USERS_SUCCESS,
        payload: payload,
    };
};

export const fetchUser = (payload) => {
    return {
        type: FETCH_USER,
        payload: payload,
    };
};

export const fetchUserFailure = (error) => {
    return {
        type: FETCH_USER_FAILURE,
        error: error,
    };
};

export const fetchUserSuccess = (response) => {
    return {
        type: FETCH_USER_SUCCESS,
        response: response,
    };
};

export const fetchUserAccumulated = (payload) => {
    return {
        type: FETCH_USER_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'users',
            type: FETCH_USERS_ACCUMULATED,
        },
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/fetchUsers.js